import { initContract } from '@ts-rest/core';
import { authWinnerContract } from './winner.auth.contract';
import { adminWinnerContract } from './winner.admin.contract';

const c = initContract();

export const winnerContract = c.router(
  {
    auth: authWinnerContract,
    admin: adminWinnerContract
  },
  {
    pathPrefix: '/winner',
    strictStatusCodes: true,
  }
);

export * from './winner.auth.contract';
export * from './winner.admin.contract';
